document.querySelectorAll('a[href^="#"]').forEach((link)=>{
    link.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (target) {
            e.preventDefault();
            target.scrollIntoView({
                behavior: 'smooth'
            });
        }
    });
});

//# sourceMappingURL=Eco_cosmetics.998aa2ed.js.map
